
export default {
    // 登录相关
  loginValidateTicket: 'bz-mix/login/validate-ticket',
  logout: 'bz-mix/logout',
  loginUserInfo: 'bz-mix/login/user-info',    // 获取已登录用户的详细信息
    // 平台跳转授权请求
  grantJumpPlatform: 'bz-mix/grant/platform-jump',
    // 定制页面
  customer: 'bz-mix/bz/get/list/custom', // 获取定制页面数据
  gitPic: 'bz-mix/bz/screen/set', // 设置图片
  delPic: 'bz-mix/bz/screen/pic/del',
  rollWords: 'bz-mix/bz/agent/introduce/update', // 滚动字幕
  picName: 'bz-mix/bz/file/name/set-name', // 修改图片名字
    // 详情页
  getPicVideo: 'bz-mix/bz/get/details/list', // 拉取图片和视频
  delPicVideo: 'bz-mix/bz/screen/pic/del', // 删除图片视频
  setPicVideo: 'bz-mix/bz/screen/set', // 上传图片视频
  showPicVideo: 'bz-mix/bz/type/setting/show', // 显示图片视频
    // 图片排序
  dragPicUrl: 'bz-mix/bz/screen/set-sort',
    // 跑马灯
  getFontSize: 'bz-mix/bz/agent/title/get-font', // 获取字体
  getSubtitle: 'bz-mix/bz/agent/title/get-subtitle', // 获取字幕
  setSubtitle: 'bz-mix/bz/agent/title/set-subtitle', // 设置字幕
    // 客户反馈
  feedBack: 'bz-mix/bz/mix-agent/feed-back/get-list',
    // 拖拽
    // dragPicUrl: "bz-mix/bz/screen/set-sort",

    // 轮询拉取投影仪消息
  getRemindMsg: 'bz-mix/bz/agent/getRemindMsg',
    // 投影仪房间管理
  getPsnList: 'bz-mix/bz/mix-agent/psn/list/get',    // 获取门店psn列表
  editRoom: 'bz-mix/bz/mix-agent/room/edit',         // 房间编辑（新增，修改）
  getRoomList: 'bz-mix/bz/mix-agent/room/list/get',  // 房间列表
  delRoom: 'bz-mix/bz/mix-agent/room/del',           // 房间删除
  unbundRoom: 'bz-mix/bz/mix-agent/room/psn/unbind', // 房间解绑psn

    // 酒店管理新加
  getinterface: 'bz-mix/bz/agent/getStoreBootInterface', // 获取界面启动
  setinterface: 'bz-mix/bz/agent/setStoreBootInterface',  // 设置界面启动

    // 订单、角色、营收相关
  getOrderList: 'bz-mix/bz/projector-retail/web/retail-order/list',               // 获取订单列表
  getOrderDetail: 'bz-mix/bz/projector-retail/web/retail-order/info',             // 获取订单详情
  getRevenueList: 'bz-mix/bz/settlement/revenue/list/get',                        // 获取营收列表
  getRevenueDetail: 'bz-mix/bz/settlement/revenue/detail',                        // 获取营收详情
  refuseOrder: 'bz-mix/bz/projector-retail/web/retail-order/refuse',              // 拒绝订单
  acceptOrder: 'bz-mix/bz/projector-retail/web/retail-order/distribution',        // 接受（配送）订单
  excelExport: 'bz-mix/bz/settlement/excel/export',                               // excel导出
  downloadExcel: 'bz-oss/excel/download',                                         // 下载excel文件
  getDistributionStaff: 'bz-mix/bz/bz-staff/get-distribution-list',               // 获取配送人员列表
  waitDistribution: 'bz-mix/bz/projector-retail/web/retail-order/num-notic',      // 代配送数量和提醒
    // 权限角色相关
  getStaffList: 'bz-mix/bz/bz-staff/get-list',                     // 获取员工列表
  addStaff: 'bz-mix/bz/bz-staff/create-staff',                     // 新增员工
  editStaff: 'bz-mix/bz/bz-staff/update-staff',                    // 编辑员工
  delStaff: 'bz-mix/bz/bz-staff/del-staff',                        // 删除员工
  getRoleList: 'bz-mix/bz/role/get-list',                          // 获取角色列表
  getRoleDetail: 'bz-mix/bz/role/get-info',                        // 获取角色详情
  modifyPass: 'bz-mix/bz/bz-staff/change-pwd',                    // 老板修改员工修改密码
  modifymyBoss: 'bz-mix/bz/change/pwd',                            // 老板修改自己密码
  modifymyStaff: 'bz-mix/bz/bz-staff/change-self-pwd',             // 员工修改自己密码
  queryOpen: 'bz-oss/oss/store/function/ctrl',                     // 查询购物功能是否开通
    // 商品购物

    // 商品分类
  getCategoryList: 'bz-mix/bz/projector-retail/web/retail-category/list',                      // 拉取商品分类列表
  addCategory: 'bz-mix/bz/projector-retail/web/retail-category/add',        // 添加商品分类
  editCategory: 'bz-mix/bz/projector-retail/web/retail-category/edit',      // 编辑商品分类
  delCategory: 'bz-mix/bz/projector-retail/web/retail-category/delete',     // 删除商品分类

    // 商品
  getGoodsList: 'bz-mix/bz/projector-retail/web/retail/list',       // 获取商品列表
  addGoods: 'bz-mix/bz/projector-retail/web/retail/add',            // 添加商品
  editGoods: 'bz-mix/bz/projector-retail/web/retail/edit',          // 编辑商品
  delGoods: 'bz-mix/bz/projector-retail/web/retail/delete',         // 删除商品
  goodsChangeStatus: 'bz-mix/bz/projector-retail/web/retail/status',  // 修改商品上下架状态

    // 结算记录
  getRecords: 'bz-mix/bz/settlement/cycle/bill/list/get',   // 获取结算记录列表
  getRecordInfo: 'bz-mix/bz/settlement/cycle/bill/detail',   // 获取结算记录详情
  getSettlementInfo: 'bz-oss/oss/store/settlement/data/get',   // 获取出账入账详情
  getUnPayRecordInfo: 'bz-oss/oss/store/settlement/data/get',     // 获取未结算账单详情

    // 日志管理
  getOperationList: 'bz-mix/bz/operation/log/list/get',       // 获取员工操作日志
  getOpeStaffList: 'bz-mix/bz/operation/staff/account/list/get',       // 获取员工列表

    // 资金流水
  getCapitalFlow: 'bz-mix/bz/mix-agent/cash-flow/list',         // 资金流水列表
  CapitalExport: 'bz-mix/bz/mix-agent/cash-flow/export',        // 资金流水导出表
  CommonDownloadExcel: 'common/excel/download',                 // 公共下载

    // 界面管理
  getInterfaceDetail: 'bz-mix/interface/getInterfaceUseInfo',     // 界面详情
  getInterfaceList: 'bz-mix/getInterfaceList',                    // 界面模块列表
  editInterfacesModule: 'bz-oss/interface/editStoreModule',       // 模块&&(二级界面)编辑
  updateModuleSort: 'bz-oss/interface/updateModuleSort',           // 模块排序
  getDefultImage: 'bz-mix/useDefaultPicture',                     // 使用默认图
  getSonModule: 'bz-oss/interface/getSonModule',                  // 二级界面列表
  deleteSonModule: 'bz-mix/deleteSonModule',                      // 删除二级界面资源
  updateSonSort: 'bz-oss/interface/updateSonSort',                 // 二级界面排序
  addPicOrVideo: 'bz-oss/interface/addPicOrVideo',                // 新增二级界面资源
  getOssList: 'bz-oss/getInterfaceList',                          // 获取oss列表资源
  getWelcomeType: 'bz-mix/bz/welcome/type/get',                   // 获取启用模式(欢迎界面)
  editWelcomeTypeUpdate: 'bz-mix/bz/welcome/type/update',         // 修改启用模式(欢迎界面)
  editPicDel: 'bz-mix/bz/welcome/pic/del',         // 修改启用模式(欢迎界面)

    // 立即消息
  realTimeSend: 'bz-mix/bz/agent/title/set-true-subtitle',        // 立即消息发送
  getNewRoomList: 'bz-mix/bz/agent/title/get-room-list',          // 立即消息获取包间
  getnewsRecord: 'bz-mix/bz/agent/title/get-true-subtitle',         // 获取立即消息记录

    // 爱奇艺1.4迭代
  getDemandRevenue: 'bz-mix/bz/revenue/count/list/get',            // 获取点播营收列表
  exportDemandRevenue: 'bz-mix/bz/revenue/count/excel/export',     // 点播营收报表导出
  getDemandList: 'bz-mix/bz/copyright/iqiyi-order-list',           // 点播订单列表
  exportDemandList: 'bz-mix/bz/copyright/iqiyi-order-export',      // 点播订单导出
  demandSettlementInfo: 'bz-mix/bz/copyright/account-info',        // 点播结算分账信息
  getSettleStatistic: 'bz-mix/bz/copyright/settle-statistic',      // 点播结算统计金额
  getDemandStaList: 'bz-mix/bz/copyright/settle-list',             // 点播结算列表

    // 1.5迭代相关
  getControlpwd: 'bz-mix/bz/control/key/get',                    // 获取控制台密码
  editControlpwd: 'bz-mix/bz/control/key/update',                // 编辑控制台密码
  recoveryControlpwd: 'bz-mix/bz/control/key/default/set',       // 恢复控制台密码
  getFontColor: 'bz-mix/bz/font/face/get',                       // 获取字体颜色大小
  setFontColor: 'bz-mix/bz/font/face/update',                    // 设置字体颜色大小
  recoveryFontColor: 'bz-mix/bz/font/default/set',               // 恢复字体颜色大小
  getAppList: 'bz-oss/interface/getAppList',                      // 拉取软件列表
  oneKeyDefault: 'bz-oss/interface/setDefaultModule',             // 一键恢复默认

    // 商家扫码支付技术服务费相关
  specialCompets: 'fbs/bz/tech-service-fee/get-expire-permission',     // 获取特殊权限
  getRecordList: 'fbs/bz/tech-service-fee/record-list',                // 获取支付记录
  payBill: 'fbs/bz/tech-service-fee/create-order',                     // 服务费下单
  getEffectiveInfo: 'fbs/bz/tech-service-fee/get-parames-for-order',    // 获取有效信息

    // 别样红欢迎页面
    // https://gitlab.qnbar.com/qnbar_developer/qnbar_api/wikis/byh-proj
  getMessageInfo: 'bz-mix/bz/welcome/message/get',                 // 获取欢迎页面信息
  editMessageInfo: 'bz-mix/bz/welcome/message/edit',               // 编辑欢迎页面信息
  setWelcomPic: 'bz-mix/bz/welcome/pic/set',                       // 背景图片设置
  delWelcomPic: 'bz-mix/bz/welcome/pic/del',                       // 背景图片删除
  setWelcomMusic: 'bz-mix/bz/welcome/music/set',                   // 背景音乐设置
  delWelcomMusic: 'bz-mix/bz/welcome/music/del',                   // 背景音乐删除
  byhCheck: 'bz-mix/bz/welcome/byh/check',                             // 别样红菜单权限
  setWelcomeStatus: 'bz-mix/bz/welcome/open/status',               // 开通或关闭欢迎信息
  getWelcomeStatus: 'bz-mix/bz/welcome/open/status/get',           // 获取当前欢迎信息状态

    // 租赁管理
  storeRecord: 'bz-mix/leaseOrder/storeRecord',                     // 购买记录
  exportStoreRecord: 'bz-mix/leaseOrder/exportStoreRecord',         // 导出购买记录
  createOrder: 'bz-mix/leaseOrder/createOrder',                     // 创建订单
  leaseKeysPrice: 'bz-mix/bz/lease/keys/price',                     // 密钥购买
  getLeasePsn: 'bz-mix/bz/lease/psn/get',                           // 获取设备
  detailLeaseKeys: 'bz-mix/bz/lease/keys/detail',                   // 密钥详情
  detailLeaseKeysInfo: 'bz-mix/bz/lease/keys/detail/info',          // 密钥详情info
  exportLeaseDetail: 'bz-mix/bz/lease/exportLeaseDetail',           // 导出密钥详情
  exportDetailInfo: 'agent/bz/qnbar-agent/lease/exportDetailInfo',  // 导出密钥详情info
  leaseKeyOther: 'bz-mix/bz/lease/keys/other',  // 密钥剩余情况
    // 租赁三
  leaseDistributeList: 'bz-mix/bz/lease/distribute/logs/get', // 获取分发记录
  leaseExportDistributeKey: 'bz-mix/bz/lease/exportDistributeKeys', // 导出分发记录
  getRoomLease: 'bz-mix/bz/lease/room/get', // 获取房间列表
  getModelList: 'bz-mix/bz/lease/keys/models', // 获取可选型号
  getStoreStatus: 'bz-mix/bz/lease/store/status/get', // 获取门店租赁状态
  merchantRoomOpen: 'bz-mix/bz/lease/room/open', // 开启房间
  merchantRoomClose: 'bz-mix/bz/lease/room/close', // 关闭房间
  leaseExportPsnGet: 'bz-mix/bz/lease/exportLeasePsnGet', // 导出设备

    // 上传相关
  commonOssUpload: 'common/oss/upload',                      // 拉取上传配置
  uploadWSCommonOss: 'common/ws/upload',      						   // 拉取上传配置(网宿)
  HuaWeiCommonOssUpload: 'common/hwobs/upload',						   // 拉取华为云上传配置
  HuaWeiSectionUpload: 'common/hwobspart/upload',					   // 拉取华为云分段上传配置
    // HuaWeiSectionUploadInit: 'common/hwobspart/init',						// 华为云分段上传初始化配置
  HuaWeiMergeSection: 'common/hwobspart/merge',						   // 华为云分段上传后合并端
  HuaWeiCancelUpload: 'common/hwobspart/cancel',					   // 取消华为云上传
  HuaweiAndWsUpload: 'common/upload',								         // 获取上传配置（根据后端的返回的结果，决定是华为还是网宿）

    // 维修相关
  addRepair: 'warehouse/mix/repair/add',                        // 新增维修单
  getRepair: 'warehouse/mix/repair/get',                        // 查询维修单
  editDetailsRepair: 'warehouse/mix/repair/edit',               // 编辑维修单信息
  getWarehouseGoods: 'warehouse/goods/list',                    // 获取商品列表
  payOrderRepair: 'warehouse/agent/repair/order/pay',           // 下单支付
  editCheckStatusWarehouse: 'warehouse/mix/check/status/edit',  // 更新维修单状态接口
  queryActivationTime: 'warehouse/mix/psn/check',               // 查询激活时间
  getFileWarehouse: 'warehouse/mix/file/get',                   // 附件查询
  addFileWarehouse: 'warehouse/mix/file/add',                   // 附件新增
  deleteFileWarehouse: 'warehouse/mix/file/del',                // 附件删除
  editCheckStatusWarehouse: 'warehouse/mix/check/status/edit',  // 更新维修单状态接口
  getLogsRepair: 'warehouse/mix/repair/logs/get',               // 日志查询
  editPriceRepair: 'warehouse/mix/repair/price/edit',           // 批量改价
  editStatusPayRepair: 'warehouse/mix/repair/pay/status/edit',  // 结算审核
  getOsnOrderRepair: 'warehouse/mix/repair/order/osn/get',      // 订单查询
  getDetailsRepair: 'warehouse/mix/repair/details/get',         // 查询维修单详情
  getprovincelist: 'common/oss/region/get-province',            // 省份列表
  getcitylist: 'common/oss/region/get-city',                    // 市区列表
  getAreasList: 'common/oss/region/get-areas',                  // 区县列表
  checkPriceOrder: 'warehouse/mix/order/price/check',           // 价格0结算

    // 界面六相关
  getInterfaceSix: 'bz-mix/interface/six/module/list',							  // 查询界面六
  editInterfaceSixLogo: 'bz-mix/interface/six/logo/edit',						      // 编辑界面六logo
  editInterfaceSixTheme: 'bz-mix/interface/six/theme/edit',						  // 编辑界面六主题
  editInterfaceSixbackground: 'bz-mix/interface/six/background/edit',			      // 编辑界面六背景图
  editInterfaceSixHomepageModule: 'bz-mix/interface/six/media/edit',			      // 编辑界面六首页模块
  InterfaceSixAddModule: 'bz-mix/interface/six/module/add',						  // 界面六新增模块
  InterfaceSixEditModule: 'bz-mix/interface/six/module/edit',					      // 界面六编辑模块
  InterfaceSixEditModuleOrder: 'bz-mix/interface/six/module/sort/edit',			  // 界面六编辑模块顺序
  InterfaceSixDelModule: 'bz-mix/interface/six/module/del',						  // 界面六删除模块
  InterfaceSixGetContent: 'bz-mix/interface/six/extension/get',					  // 界面六获取内容
  InterfaceSixAddContent: 'bz-mix/interface/six/extension/add',					  // 界面六新增内容
  InterfaceSixEditContent: 'bz-mix/interface/six/extension/edit',				      // 界面六编辑内容
  InterfaceSixDelContent: 'bz-mix/interface/six/extension/del',					  // 界面六删除内容
  InterfaceSixDelContentSort: 'bz-mix/interface/six/extension/sort/edit',		      // 界面六内容排序
  InterfaceSixediteMovieAddresses: 'bz-mix/interface/six/url/edit',				  // 界面六编辑电影url地址
  InterfaceSixaKeyRecovery: 'bz-mix/interface/six/module/init',                     // 界面六一键恢复
  InterfaceSixEditLiveTv: 'bz-mix/interface/six/live/edit',                     // 界面六编辑直播设置
  InterfaceRestoreSixVideo: 'bz-mix/interface/six/home/video/init',					  // 界面六恢复首页视频
  InterfaceRestoreContentVideo: 'bz-mix/interface/six/extension/video/init',		  // 界面六恢复内容视频

	// 网宿上传相关
  uploadWSCommonOss: 'common/ws/upload',      // 拉取上传配置(网宿)
  DeleteWSFiles: 'common/ws/del',             // 单个删除网宿云上的文件
  BatchDeletion: 'common/ws/batch_del',       // 批量删除网宿云上的文件

    // 界面七相关接口
  getInterfaceSeven: 'bz-mix/interface/seven/module/list',							  // 查询界面七
  editInterfaceSevenLogo: 'bz-mix/interface/seven/logo/edit',						      // 编辑界面七logo
  editInterfaceSevenTheme: 'bz-mix/interface/seven/theme/edit',						  // 编辑界面七主题
  editInterfaceSevenbackground: 'bz-mix/interface/seven/background/edit',			      // 编辑界面七背景图
  editInterfaceSevenHomepageModule: 'bz-mix/interface/seven/media/edit',			      // 编辑界面七首页模块
  editInterfaceSevenWelecomeText: 'bz-mix/interface/seven/home/msg/edit',               // 编辑首页文字
  InterfaceSevenAddModule: 'bz-mix/interface/seven/module/add',						  // 界面七新增模块
  InterfaceSevenEditModule: 'bz-mix/interface/seven/module/edit',					      // 界面七编辑模块
  InterfaceSevenEditModuleOrder: 'bz-mix/interface/seven/module/sort/edit',			  // 界面七编辑模块顺序
  InterfaceSevenDelModule: 'bz-mix/interface/seven/module/del',						  // 界面七删除模块
  InterfaceSevenGetContent: 'bz-mix/interface/seven/extension/get',					  // 界面七获取内容
  InterfaceSevenAddContent: 'bz-mix/interface/seven/extension/add',					  // 界面七新增内容
  InterfaceSevenEditContent: 'bz-mix/interface/seven/extension/edit',				      // 界面七编辑内容
  InterfaceSevenDelContent: 'bz-mix/interface/seven/extension/del',					  // 界面七删除内容
  InterfaceSevenDelContentSort: 'bz-mix/interface/seven/extension/sort/edit',		      // 界面七内容排序
  InterfaceSevenEditMovieAddresses: 'bz-mix/interface/seven/url/edit',				  // 界面七编辑电影url地址
  InterfaceSevenaKeyRecovery: 'bz-mix/interface/seven/module/init',                     // 界面七一键恢复
  InterfaceSevenEditLiveTv: 'bz-mix/interface/seven/live/edit',                     // 界面七编辑直播设置
  InterfaceRestoreVideo: 'bz-mix/interface/seven/home/video/init',					  // 界面七恢复首页视频
  InterfaceSevenRestoreContentVideo: 'bz-mix/interface/seven/extension/video/init',	  // 界面七恢复内容视频
  InterfaceSevenEditIndexModuleOrder: 'bz-mix/interface/seven/home/module/sort/edit',   // 编辑首页模块顺序

	// 界面设置相关接口
  QueryDeviceInterfaceSettings: 'bz-mix/interface/set/get',							  //  查询设备界面设置
  EditDeviceInterfaceSettings: 'bz-mix/interface/set/edit',							  //  编辑设备界面设置
  EditTimeDisplaySettings: 'bz-mix/bz/agent/time/set/edit',               //  编辑时间设置
  	GetTimeDisplaySettings: 'bz-mix/bz/agent/time/set/get',

    // 界面审核
  bzmixInterfaceAuditList: 'bz-mix/interface/audit/list',                              //  BZMIX-门店查询审核记录列表
  bzmixInterfaceAuditItems: 'bz-mix/interface/audit/items',                            //  BZMIX-查询指定门店内容类型待审核的列表
  bzWelcomeLogoSet: 'bz-mix/bz/welcome/logo/set',                                              //  欢迎界面(3,4)修改logo

    // 美团酒店
  getHotelInfo: 'bz-mix/interface/mt-store/list',                               // 获取美团酒店数据
  eidtMeituanAudiovisual: '/bz-mix/interface/mt-store/editMTYY',                // 编辑美团影音
  editMeituanJiguangTV: '/bz-mix/interface/mt-store/editJGTV',                  // 编辑极光TV
  editMeituanCableTV: '/bz-mix/interface/mt-store/editYXDS',                    // 编辑有线电视
  editMeituanOneKeyScreen: '/bz-mix/interface/mt-store/editYJTP',               // 编辑一键投屏
  editMeiTuanHotelIntroduce: '/bz-mix/interface/mt-store/editJDJS',             // 编辑酒店介绍
  editMeiTuanViewingGuide: '/bz-mix/interface/mt-store/editGYZN',               // 编辑观影指南
  editMeiTuanViewingSweetDream: '/bz-mix/interface/mt-store/editMMSG',          // 编辑美梦时光
  getQueryWeather: 'bz-mix/interface/mt-store/queryWeather',                    // 查询天气
  MeirTuanOnkeyRecovery: 'bz-mix/interface/mt-store/initDefaultJDJS',           // 一键恢复
  editMeituanAudioVideoInterface: '/bz-mix/interface/mt-store/editFaceMTYY',    // 编辑美团影音界面
  editMeituanlogo: '/bz-mix/interface/mt-store/editLogo',                     // 编辑logo
  GetDutyStaff: 'bz-mix/bz/get/duty/staff',                                     //获取人工通道 投诉电话
  editMTWMContentImage: 'bz-mix/interface/mt-store/editMTWM',                   // 编辑美团外卖内容图片

  //应用商城
  mixThirdAppNewGet: 'software/mix/thirdApp/new/get',                           //获取软件
  mixThirdAppOpBindStore: 'software/mix/thirdApp/opBindStore',                  //（推送/取消推送）软件
  
  //租赁三
  mixAgentRoomListGet: 'bz-mix/bz/mix-agent/room/list/get',                     //查询房间列表
  mixAgentRoomEdit: 'bz-mix/bz/mix-agent/room/edit',                            //编辑房间
  mixAgentRoomSortEdit: 'bz-mix/bz/mix-agent/room/sort/edit',                   //编辑房间排序号
  leaseXcRoomList: 'bz-mix/bz/lease/xc/room/list',                              //查询租赁3客房授权
  leaseXcRoomOpen: 'bz-mix/bz/lease/xc/room/open',                              //门店主动授权or同意授权
  leaseXcRoomBatchOpen: 'bz-mix/bz/lease/xc/room/batch/open',                   //批量同意授权
  leaseXcRoomClose: 'bz-mix/bz/lease/xc/room/close',                            //关闭授权
  leaseXcRecordList: 'bz-mix/bz/lease/xc/record/list',                          //门店查询租赁3授权记录
  leaseXcRecordReport: 'bz-mix/bz/lease/xc/record/report',                      //门店查询租赁3授权统计
  leaseXcRecordReportExport: 'bz-mix/bz/lease/xc/record/report/export',         //门店导出租赁3授权统计
  leaseXcDetailReport: 'bz-mix/bz/lease/xc/detail/report',                      //门店查询租赁3授权明细
  leaseXcDetailReportExport: 'bz-mix/bz/lease/xc/detail/report/export',         //门店导出租赁3授权明细

  //云游戏
  gameOrderList: 'bz-mix/game/order/list',                                      //查询云游戏订单
  gameOrderExport: 'bz-mix/game/order/export',                                  //导出云游戏订单

  //应用卸载
  allowUninstallList: "bz-mix/allow/uninstall/list",                            //允许卸载列表
  allowUninstallAdd: "bz-mix/allow/uninstall/add",                              //卸载软件
  allowUninstallRemove: "bz-mix/allow/uninstall/remove",                        //取消卸载

  //清除缓存
  commonClearrojectorCache: "common/clear/projector/cache",                 //清除缓存 
  commonClearStore: '/common/clear/store',                                  // 清除门店缓存
  mixAgentRoomUnifyWifi: 'bz-mix/bz/mix-agent/room/unify/wifi',             // 查询门店wifi

  //界面八
  interfaceEightModuleList: "bz-mix/interface/eight/module/list",       //门店界面查询
  interfaceEightLogoEdit: "bz-mix/interface/eight/logo/edit",           //编辑logo
  interfaceEightFirstModuleEdit: "bz-mix/interface/eight/first/module/edit", //编辑一级模块
  interfaceEightModuleEdit: "bz-mix/interface/eight/module/edit",       //编辑二级模块
  interfaceEightMediaEdit: "bz-mix/interface/eight/media/edit",         //编辑首页模块
  interfaceEightExtensionAdd: "bz-mix/interface/eight/extension/add",   //新增内容
  interfaceEightExtensionEdit: "bz-mix/interface/eight/extension/edit", //编辑内容
  interfaceEightExtensionDel: "bz-mix/interface/eight/extension/del",   //删除内容
  interfaceEightExtensionGet: "bz-mix/interface/eight/extension/get",   //查询内容
  interfaceEightExtensSortEdit: "bz-mix/interface/eight/extension/sort/edit", // 内容排序
  interfaceEightModuleInit: "bz-mix/interface/eight/module/init",       //一键恢复
  interfaceEightModuleAdd: "bz-mix/interface/eight/module/add",         //新增模块
  interfaceEightModuleDel: "bz-mix/interface/eight/module/del",         //删除模块
  interfaceEightModuleSortEdit: "bz-mix/interface/eight/module/sort/edit", //模块排序
  interfaceEightMediaDelete: "bz-mix/interface/eight/media/delete",       //删除首页视频
}



// WEBPACK FOOTER //
// ./src/svrapi.js